module.exports = __webpack_public_path__ + "static/qa_photo-1feb9b43ab401efd3deb7ffff2910190.jpg";